/**
 * custom-mobile-nav.js — giorgatos.com
 * ─────────────────────────────────────────────────────────────
 * Enhances the Zest mobile nav drawer:
 *   1. Parent nav links with children expand their submenu on tap
 *      instead of navigating — no separate "+" toggle button needed.
 *   2. Accordion behaviour: opening one top-level item auto-closes
 *      all other open top-level items.
 *   3. Sub-items (L2 with L3 children) get the same click-to-expand
 *      behaviour.
 *
 * Depends on: Zest's collapsible-tab custom element (collapsible-tab.js)
 * Safe to run multiple times — guards with drawer.dataset.customNavInit
 */

(function () {
  'use strict';

  function setupMobileNavLinks () {
    var drawer = document.getElementById('Drawer-MobileNav');
    if (!drawer || drawer.dataset.customNavInit) return;
    drawer.dataset.customNavInit = 'true';

    /* ── Level-1 parent items (top-level links with sub-menus) ── */
    var parentItems = Array.prototype.slice.call(
      drawer.querySelectorAll('.f-mobile-nav__item--has-child')
    );

    parentItems.forEach(function (li) {
      var link       = li.querySelector(':scope > .f-mobile-nav__link');
      var collapsible = li.querySelector(':scope > collapsible-tab');
      if (!link || !collapsible) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = !!collapsible.selected;

        /* Accordion: close every other open L1 item first */
        if (!isOpen) {
          parentItems.forEach(function (otherLi) {
            if (otherLi === li) return;
            var otherCol = otherLi.querySelector(':scope > collapsible-tab');
            if (otherCol && otherCol.selected) {
              otherCol.close();
            }
          });
        }

        /* Toggle this item */
        collapsible.toggle();
      });
    });

    /* ── Level-2 sub-items (sub-links that have grandchildren) ── */
    var subParentItems = Array.prototype.slice.call(
      drawer.querySelectorAll('.f-mobile-nav__sub-item--has-child')
    );

    subParentItems.forEach(function (li) {
      var link        = li.querySelector(':scope > .f-mobile-nav__sub-link');
      var collapsible  = li.querySelector(':scope > collapsible-tab');
      if (!link || !collapsible) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        collapsible.toggle();
      });
    });
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileNavLinks);
  } else {
    setupMobileNavLinks();
  }

  /* Safety net: re-run shortly after the drawer opener is tapped,
     in case the component is lazy-rendered or re-stamped.          */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer="#Drawer-MobileNav"]')) {
      setTimeout(setupMobileNavLinks, 120);
    }
  });
})();
